// Walidacja progów cenowych pozycji oferty. Schematy używane synchronicznie
// w `PriceThresholdsEditor` (handleSave) — bez Formik, ręczne errors state.

import * as Yup from 'yup';

import { IPriceThreshold } from 'api/endpoints/useGetSalesCrmOfferPositions';

/**
 * Walidacja pojedynczego progu: dodatnia ilość (int) i dodatnia cena (decimal).
 * Komunikaty są kluczami i18n — UI tłumaczy w renderze.
 */
export const singleThresholdSchema = Yup.object({
  qtyFrom: Yup.number()
    .typeError('Ilość musi być większa od zera.')
    .integer('Ilość musi być większa od zera.')
    .positive('Ilość musi być większa od zera.')
    .required('Ilość musi być większa od zera.'),
  price: Yup.number()
    .typeError('Cena musi być większa od zera.')
    .positive('Cena musi być większa od zera.')
    .required('Cena musi być większa od zera.')
});

/**
 * Walidacja całej listy: każdy element przechodzi `singleThresholdSchema`,
 * dodatkowo kolejne `qtyFrom` muszą być ściśle rosnące (po posortowaniu).
 */
export const thresholdsListSchema = Yup.array()
  .of(singleThresholdSchema)
  .test(
    'qtyFrom-ascending',
    'Ilość musi być większa od poprzedniego progu.',
    (arr) => {
      if (!arr || arr.length < 2) return true;
      const sorted = [...arr].sort((a, b) => (a?.qtyFrom ?? 0) - (b?.qtyFrom ?? 0));
      for (let i = 1; i < sorted.length; i++) {
        if ((sorted[i]?.qtyFrom ?? 0) <= (sorted[i - 1]?.qtyFrom ?? 0)) return false;
      }
      return true;
    }
  );

/**
 * Miękka walidacja: ceny powinny maleć wraz ze wzrostem ilości.
 * Zwraca `true` jeśli posortowana lista ma malejące lub równe ceny.
 */
export const isPriceDescending = (arr: IPriceThreshold[]): boolean => {
  if (arr.length < 2) return true;
  const sorted = [...arr].sort((a, b) => a.qtyFrom - b.qtyFrom);
  return sorted.every((t, i) => i === 0 || t.price <= sorted[i - 1].price);
};
